import React from 'react';
import styles from './TeacherMessagesTab.module.css';

const TeacherMessagesTab = ({ 
  sentMessages, 
  onViewMessage, 
  selectedMessage, 
  showMessageModal, 
  closeMessageModal, 
  tabId = "messages", 
  tabLabel = "Messages" 
}) => {

  return (
    <div
      tabId={tabId}
      tabLabel={tabLabel}
      className={styles.messagesContainer}
    >
      <div className={styles.messagesWrapper}>
        <h4 className={styles.messagesTitle}>
          Messages Sent to Students
        </h4>

        {sentMessages.length === 0 ? (
          <aside className={styles.emptyState}>
            📭 No messages sent to students yet. Send a message to get started!
          </aside>
        ) : (
          <aside className={styles.inboxContainer}>
            {/* INBOX HEADER */}
            <div className={styles.inboxHeader}>
              <div className={styles.headerRow}>
                <div className={`${styles.headerColumn} ${styles.headerColumnFrom}`}>From</div>
                <div className={`${styles.headerColumn} ${styles.headerColumnSubject}`}>Subject</div>
                <div className={`${styles.headerColumn} ${styles.headerColumnDate}`}>Date</div>
                <div className={`${styles.headerColumn} ${styles.headerColumnStatus}`}>Status</div>
              </div>
            </div>

            {sentMessages.map((message) => (
              <header
                key={message._id}
                onClick={() => onViewMessage(message)}
                className={`${styles.messageItem} ${selectedMessage?._id === message._id ? styles.messageItemSelected : ''}`}
              >
                <div className={styles.messageRow}>
                                  <div className={`${styles.messageColumn} ${styles.messageColumnFrom}`}>
                  {message.studentName || 'Student'}
                </div>
                  <div className={`${styles.messageColumn} ${styles.messageColumnSubject}`}>
                    Message to Student
                  </div>
                  <div className={`${styles.messageColumn} ${styles.messageColumnDate}`}>
                    {new Date(message.createdAt).toLocaleDateString()}
                  </div>
                  <div className={`${styles.messageColumn} ${styles.messageColumnStatus}`}>
                    {message.reply ? (
                      <span className={styles.repliedBadge}>✅ Replied</span>
                    ) : (
                      <span className={styles.unreadBadge}>📬 Unread</span>
                    )}
                  </div>
                </div>
              </header>
            ))}
          </aside>
        )}

        {/* Message Modal */}
        {showMessageModal && selectedMessage && (
          <div className={styles.modalOverlay}>
            <div className={styles.modalContent}>
              <div className={styles.modalHeader}>
                <h5 className={styles.modalTitle}>
                  Message to {selectedMessage.studentName || 'Student'}
                </h5>
                <button
                  onClick={closeMessageModal}
                  className={styles.closeButton}
                >
                  ×
                </button>
              </div>

              <div className={styles.modalBody}>
                <div className={styles.messageSection}>
                  <h6 className={styles.messageTitle}>
                    Your Message:
                  </h6>
                  <p className={styles.messageText}>
                    {selectedMessage.message}
                  </p>
                </div>

                {selectedMessage.reply ? (
                  <div className={styles.replySection}>
                    <h6 className={styles.replyTitle}>
                      Student's Reply:
                    </h6>
                    <p className={styles.replyText}>
                      {selectedMessage.reply}
                    </p>
                    <div className={styles.replyDate}>
                      Replied on: {new Date(selectedMessage.repliedAt).toLocaleDateString()}
                    </div>
                  </div>
                ) : (
                  <div className={styles.noReplySection}>
                    <p className={styles.noReplyText}>
                      Student hasn't replied yet.
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default TeacherMessagesTab; 